import React from 'react';
import { Modal } from 'react-bootstrap';
import moment from 'moment';

const HistoryTanggalKunjungan = ({
  isModalShow,
  setIsModalShow,
  visitDateHistory,
}) => (
  <>
    <Modal show={ isModalShow } onHide={ () => setIsModalShow(false) }>
      <Modal.Header>
        <h3>Riwayat Tanggal Kunjungan</h3>
      </Modal.Header>
      <Modal.Body>
        <div
          className='timeline timeline-one-side'
          data-timeline-content='axis'
          data-timeline-axis-style='dashed'>
          {visitDateHistory.length
            ? visitDateHistory.map((v,i) => {
              return (
              // <p>{`Tanggal Kunjungan : ${ v.visit_date } | Pengubah : ${ v.nama } | Alasan : ${ v.alasan }`}</p>
                <div className='timeline-block'>
                  <span
                    className={ `timeline-step ${
                      i === visitDateHistory.length - 1
                        ? 'badge-primary'
                        : 'badge-success'
                    }` }>
                    <i className='fab fa-font-awesome-flag' />
                  </span>
                  <div className='timeline-content'>
                    <small className='text-muted font-weight-bold'>
                      {moment(v.visit_date).format('DD-MM-YYYY')}
                    </small>
                    <h5 className=' mt-3 mb-0'>Pengubah</h5>
                    <p className=' text-sm mt-1 mb-0'>{v.nama || '-'}</p>
                    <h5 className=' mt-3 mb-0'>Alasan</h5>
                    <p className=' text-sm mt-1 mb-0'>{v.alasan || '-'}</p>
                  </div>
                </div>
              );
            })
            : 'Tidak ada riwayat'}
        </div>
      </Modal.Body>
    </Modal>
  </>
);

export default HistoryTanggalKunjungan;
